import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { colorLink400, fontFamilyPrimary } from '@/styleUtils';

export const Button = styled(Link)`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  width: 100%;
  font: 400 14px/16px ${fontFamilyPrimary};
  letter-spacing: 0.14px;
  color: ${colorLink400};

  &:visited {
    color: ${colorLink400};
  }
`;

export default Button;
